import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'prop-types';
import styled from 'styled-components';
import { TREE_DEFAULT_BORDER_WIDTH } from '../../constants.js';

var TreeDropBar = styled.div.withConfig({
  displayName: "TreeDropBar",
  componentId: "sc-hn111g-0"
})(function (_ref) {
  var isDragOver = _ref.isDragOver,
      position = _ref.position,
      theme = _ref.theme;
  var padding = 4;
  return _objectSpread(_objectSpread({}, position === "top" ? {
    top: -padding - 1
  } : {
    bottom: -padding - 1
  }), {}, {
    opacity: isDragOver ? 1 : 0,
    padding: "".concat(padding, "px 0"),
    position: "absolute",
    width: 260,
    zIndex: 2,
    "&::after": {
      content: "''",
      borderBottom: "dashed ".concat(TREE_DEFAULT_BORDER_WIDTH, "px ").concat(theme.CTAColors.primaryVariant),
      display: "block",
      height: 0
    }
  });
});

export { TreeDropBar };
